import { v4 as uuid } from "uuid";

export const flattenLayout = (layout) => {
  const knownGroups = {};
  const flattenedLayout = [];

  if (!layout) {
    return [];
  }

  for (const item of layout) {
    if (item.level === 'group') {
      knownGroups[item.group_id] = true;

      const rows = item.children;

      for (const item of rows) {
        for (const asset of item.children) {
          flattenedLayout.push(asset);
        }
      }

      if (!item?.children?.length) {
        flattenedLayout.push(item);
      }
    }

    if (item.level !== 'group') {
      flattenedLayout.push(item);
    }
  }

  return flattenedLayout;
}

const createRows = (groupItems) => {
  const rows = [];
  const knownRows = {};

  for (const item of groupItems) {
    if (!knownRows[item.row_id] && item.row_id) {
      const rowItems = groupItems.filter((asset) => asset.row_id === item.row_id);
      const row = {
        id: item.row_id,
        level: 'row',
        children: rowItems,
      }
      knownRows[item.row_id] = true;

      rows.push(row);
    }

    if (!item.row_id) {
      const row = {
        id: uuid(),
        level: 'row',
        children: [ item ],
      }

      rows.push(row);
    }
  }

  return rows;
}

const getGroupItems = (groupId, itemStack) => {
  const groupItems = itemStack.filter((item) => item.group_id === groupId);
  return createRows(groupItems);
}

export const formatData = (data) => {
  const formatted = [];
  const itemStack = [ ...data ];

  const knownGroups = {};

  for (let i = 0; i < itemStack.length; i++) {
    const item = itemStack[i];

    if (!knownGroups[item.group_id] && item.group_id) {
      const groupItems = getGroupItems(item.group_id, itemStack);
      knownGroups[item.group_id] = true;

      const group = {
        id: item.group_id,
        level: 'group',
        children: groupItems,
      }

      formatted.push(group);
    }

    if (!item.group_id) {
      formatted.push({ ...item, level: 'asset' })
    }
  }

  return formatted;
}

export const sortAndFormat = (assets: any[]) => {
  assets.sort((a, b) => a.order - b.order);
  return formatData(assets);
}
